export const dataCenter = {
  dataCenterFund: "dataCenterFund", // 资产——数据中心
  dataCenter_data: "dataCenter_data", // 数据中心-数据概览
  dataCenter_data_user: "dataCenter_data_user", // 数据中心-数据概览-用户概览
  dataCenter_data_content: "dataCenter_data_content", // 数据中心-数据概览-内容概览
  dataCenter_data_order: "dataCenter_data_order", // 数据中心-数据概览-服务订单概览
  dataCenter_user: "dataCenter_user", //数据中心_用户数据
  dataCenter_content: "dataCenter_content", //数据中心_内容数据
  dataCenter_order: "dataCenter_order", //数据中心_服务订单
  dataCenter_order_export: "dataCenter_order_export", //数据中心_服务订单
};
